import {Component} from 'react';
import h from 'react-hyperscript';
import {h3, p} from 'Components/Typography/Typography';
import BasicCard from 'Components/Cards/BasicCard';
import './ScopesError.scss';
import content from 'Assets/data/globals.json';

class ScopesError extends Component {
  render() {
    return (
      h('div', {
        className: 'scopes-error__container container flex--wrap-all',
        id: 'scopes-error',
      },
      h(BasicCard, {
        className: 'scopes-error__inner',
      }, [
        h(h3, {
          className: 'text--dark padding-bottom--md',
        }, content.errors.scopesError.title),
        h(p, {
          className: 'text--grey padding-bottom--md',
        }, content.errors.scopesError.desc1),
        h(p, {
          className: 'text--grey padding-bottom--md',
        }, content.errors.scopesError.desc2),
        h('div', {
          className: 'flex scopes-error__buttons-container',
        }, [
          h('div', {
            className: 'button button--basic scopes-error__button',
            onClick: this.props.promptScopes,
          }, content.errors.scopesError.button),
        ]),
      ]))
    );
  }
}

export default ScopesError;
